var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "applicant-link",
      class: {
        "red-background": _vm.jobApplication.killer_question_auto_failed == true
      }
    },
    [
      _c(
        "a",
        {
          staticClass: "box",
          attrs: {
            target: "_blank",
            href:
              "/recruiter/active-requisitions/applicant/" +
              _vm.jobApplication.id +
              "#" +
              _vm.phase
          }
        },
        [
          _c("strong", { staticClass: "name" }, [
            _vm._v(_vm._s(_vm.jobApplication.user.full_name))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "date text-center" }, [
            _vm._v("ID: " + _vm._s(_vm.jobApplication.user.id_number))
          ]),
          _vm._v(" "),
          _vm.jobApplication.user.user_detail.user_detail_jobs[0] &&
          _vm.jobApplication.user.user_detail.user_detail_jobs[0].role
            ? _c("div", { staticClass: "date text-center" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.jobApplication.user.user_detail.user_detail_jobs[0]
                        .role.title
                    ) +
                    "\n        "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "date text-center" }, [
            _vm._v("Applied: " + _vm._s(_vm.createdDate))
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "text-center candidate-overview-info" }, [
        _c(
          "a",
          {
            on: {
              click: function($event) {
                return _vm.toggleModal(
                  "candidateOverviewModal" + _vm.jobApplication.id
                )
              }
            }
          },
          [_vm._v("\n            Candidate Overview\n        ")]
        )
      ]),
      _vm._v(" "),
      _c("candidate-overview-modal", {
        ref: "candidateOverviewModal" + _vm.jobApplication.id,
        attrs: {
          "job-application": _vm.jobApplication,
          "csrf-token": _vm.csrfToken
        }
      }),
      _vm._v(" "),
      _vm.jobApplication.user.id_path
        ? _c("div", { staticClass: "documents icon" }, [
            _c(
              "a",
              {
                staticClass: "documents icon",
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.openPopup($event)
                  }
                }
              },
              [
                _c("i", {
                  staticClass: "fa-regular fa-id-card",
                  attrs: { title: "ID Document" }
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isPopupOpen
        ? _c("div", { staticClass: "popup" }, [
            _c("div", { staticClass: "popup-content" }, [
              _c("i", {
                staticClass: "fa-solid fa-times close-icon",
                on: { click: _vm.closePopup }
              }),
              _vm._v(" "),
              _vm.isPDF(_vm.jobApplication.user.id_path)
                ? _c("div", [
                    _c("iframe", {
                      attrs: {
                        src: _vm.jobApplication.user.id_path_cdn,
                        width: "1000px",
                        height: "600px"
                      }
                    })
                  ])
                : _c("div", [
                    _c("div", {
                      staticClass: "image-popup",
                      style: {
                        "background-image":
                          "url(" + _vm.jobApplication.user.id_path_cdn + ")"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-success",
                        attrs: {
                          href: _vm.jobApplication.user.id_path_cdn,
                          target: "_blank"
                        }
                      },
                      [_vm._v("Download Image")]
                    )
                  ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hasMatric
        ? _c(
            "div",
            {
              staticClass: "documents icon",
              on: {
                click: function($event) {
                  _vm.isPopupMatricOpen = true
                }
              }
            },
            [
              _c("i", {
                staticClass: "fa-solid fa-graduation-cap",
                attrs: { title: "Matric Qualification" }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isPopupMatricOpen
        ? _c("div", { staticClass: "popup" }, [
            _c("div", { staticClass: "popup-content" }, [
              _c("i", {
                staticClass: "fa-solid fa-times close-icon",
                on: {
                  click: function($event) {
                    _vm.isPopupMatricOpen = false
                  }
                }
              }),
              _vm._v(" "),
              _vm.matricDetails.qualification_documents.length > 0
                ? _c("div", [
                    _vm.isPDF(
                      _vm.matricDetails.qualification_documents[0].path_cdn
                    )
                      ? _c("div", [
                          _c("iframe", {
                            attrs: {
                              src:
                                _vm.matricDetails.qualification_documents[0]
                                  .path_cdn,
                              width: "1000px",
                              height: "600px"
                            }
                          })
                        ])
                      : _c("div", [
                          _c("div", {
                            staticClass: "image-popup",
                            style: {
                              "background-image":
                                "url(" +
                                _vm.matricDetails.qualification_documents[0]
                                  .path_cdn +
                                ")"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-success",
                              attrs: {
                                href:
                                  _vm.matricDetails.qualification_documents[0]
                                    .path_cdn,
                                target: "_blank"
                              }
                            },
                            [_vm._v("Download Image")]
                          )
                        ])
                  ])
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.jobApplication.user.user_detail !== null &&
      _vm.jobApplication.user.user_detail.user_detail_jobs
        ? _c("div", { staticClass: "documents icon" }, [
            _c("i", {
              staticClass: "fa-solid fa-briefcase",
              attrs: {
                title:
                  _vm.jobApplication.user.cv_details_percent_complete +
                  "% CV completed | " +
                  (_vm.jobApplication.user.work_experience_complete
                    ? "100"
                    : "0") +
                  "% work experience complete"
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.jobApplication.user.sage_sync_status
        ? _c(
            "div",
            {
              staticClass: "documents icon",
              staticStyle: {
                width: "12px",
                height: "12px",
                padding: "0",
                top: "-1px"
              },
              attrs: {
                title:
                  "Latest Synced Requisition " +
                  (_vm.jobApplication.user.external_requisition_number !== null
                    ? "(" +
                      _vm.jobApplication.user.external_requisition_number +
                      ")"
                    : "")
              }
            },
            [
              _c("img", {
                attrs: { src: "/img/icons/sage.png", alt: "Sage Logo" }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "checks" }, [
        _c("div", { staticClass: "documents icon black" }, [
          _c("i", {
            staticClass: "fa-solid fa-user-xmark",
            attrs: { title: "Not Showing Up: " + _vm.notShowingUpCount }
          }),
          _vm._v(" "),
          _vm.notShowingUpCount > 0
            ? _c("span", { staticClass: "notification-count" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.notShowingUpCount) +
                    "\n            "
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.previousRejectionTitle.length > 0
          ? _c("div", { staticClass: "documents icon black" }, [
              _c("i", {
                staticClass: "fa-solid fa-circle-exclamation",
                attrs: { title: _vm.previousRejectionTitle }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "documents icon black" }, [
          _c("i", {
            staticClass: "fa-solid fa-recycle",
            attrs: { title: "Recycles: " + _vm.recycleCount }
          }),
          _vm._v(" "),
          _vm.recycleCount > 0
            ? _c("span", { staticClass: "notification-count" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.recycleCount) +
                    "\n            "
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.jobApplication.user.baseline_score
          ? _c("div", { staticClass: "documents icon black" }, [
              _c("i", {
                staticClass: "fa-solid fa-award",
                attrs: {
                  title:
                    "Baseline Score: " + _vm.jobApplication.user.baseline_score
                }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.jobApplication.user.ifact_form !== null
          ? _c("div", { staticClass: "documents icon text-danger" }, [
              _c("i", {
                staticClass: "fa-solid fa-user-slash",
                attrs: {
                  title:
                    "iFacts Flag: " +
                    _vm.jobApplication.user.ifact_form.conviction_details
                }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.jobApplication.user.sage_log &&
        _vm.jobApplication.user.sage_log.level === "error"
          ? _c("div", { staticClass: "documents icon text-danger" }, [
              _c("i", {
                staticClass: "fa-solid fa-user-injured",
                attrs: { title: "Failed Sage Sync" }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.jobApplication.user.currently_working_for_merchant
          ? _c("div", { staticClass: "documents icon black" }, [
              _c("img", {
                staticClass: "icon-image",
                attrs: {
                  src: "https://www.mycalling.co.za/favicon.ico",
                  title: "Currently working for merchant"
                }
              })
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.bulkRecycle != ""
        ? _c("div", { staticClass: "select-application" }, [
            _c("input", {
              attrs: { type: "checkbox", title: "Select all candidates" },
              domProps: {
                value: _vm.jobApplication.id,
                checked: _vm.isSelected
              },
              on: {
                change: function($event) {
                  return _vm.updateSelectedApplication($event)
                }
              }
            })
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15b484dc", { render: render, staticRenderFns: staticRenderFns })
  }
}